"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricePreview = void 0;
var object_service_1 = require("@services/object-service");
var settings_service_1 = require("@services/settings.service");
var contract_const_1 = require("@src/const/contract.const");
var generator_const_1 = require("@src/const/dom-crud/generator.const");
var jquery_helper_const_1 = require("@src/const/dom-crud/jquery-helper.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var api_wrapper_1 = require("../../../api/api-wrapper");
var form_const_1 = require("../membership-completion/const/form.const");
var render_data_handlers_1 = require("./render-data-handlers");
var render_given_price_preview_1 = require("./render-given-price-preview");
/**
 * Renders dynamically a rate bundle from the technology api
 */
var PricePreview = /** @class */ (function () {
    function PricePreview() {
        this.config = object_service_1.ObjectService.getInstance(settings_service_1.SettingsService);
        this.apiWrapper = object_service_1.ObjectService.getInstance(api_wrapper_1.ApiWrapper);
        this.communicationService = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.offerings = [];
        this.renderPricePreview = new render_given_price_preview_1.RenderGivenPricePreview();
        this.renderPricePreviewDataHandlers = new render_data_handlers_1.RenderPricePreviewDataHandlers();
        this.useDatahandlers = false;
    }
    PricePreview.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                this.renderPricePreview.$container = this.$container;
                console.log('loading price preview module');
                // currently yond doesnt have a studio id mapping
                // TODO: Fix once yond delivers one
                // TODO: themisoft studio is a string, so the >0 check fails
                this.doRenderPricePreview();
                this.communicationService.subscribeGlobally().subscribe(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        if (data.event === 'custom' && (data.name === 'membershipSelected' || data.name === 'addonChanged')) {
                            console.log('got membership selected event, reloading price preview');
                            this.doRenderPricePreview();
                        }
                        else if (data.event === 'custom' && ((_a = data.module) === null || _a === void 0 ? void 0 : _a.moduleKey) === 'studio-selection' && data.name === 'studioSelected') {
                            // TODO: Should probably hide price preview or reset it
                        }
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    PricePreview.prototype.doRenderPricePreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var waitOffers, preview, _a, paidModules, pricePreviewHasChildren, renderedEvent;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this._studioId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.studioId);
                        this._studioName = this.getPersistedData(form_const_1.MAPPINGS.studioNameText);
                        this.termId = (0, input_output_helper_const_1._ReadFieldValue)(input_mapping_const_1._AllMappings.rateBundleTermId);
                        if (!(this.config.get.technologyType === 'themisoft' ||
                            this.config.get.technologyType === 'yond' ||
                            (((_b = this._studioId) === null || _b === void 0 ? void 0 : _b.length) && +this._studioId > 0))) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getOfferings()];
                    case 1:
                        waitOffers = _d.sent();
                        console.log('Got offerings', this.offerings);
                        if (!(this.config.get.technologyType === 'magicline' || !this.config.get.technologyType)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getMagiclinePreview()];
                    case 2:
                        _a = _d.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = undefined;
                        _d.label = 4;
                    case 4:
                        preview = _a;
                        if (!waitOffers) return [3 /*break*/, 7];
                        paidModules = this.modulesFromLocalstorage('optionalModules');
                        pricePreviewHasChildren = this.$container.children().length && !this.$container.get(0).hasAttribute('generate-full-pricing-preview');
                        if (!pricePreviewHasChildren) return [3 /*break*/, 6];
                        console.log('Price preview has children, using it with datahandlers', this.$container.children());
                        this.useDatahandlers = true;
                        this.renderPricePreview.dontRenderPricePreview = true;
                        this.renderPricePreviewDataHandlers.$container = this.$container;
                        this.renderPricePreviewDataHandlers.module = this.module;
                        return [4 /*yield*/, this.renderPricePreviewDataHandlers.reloadPricePreview(this.offerings, this.renderPricePreview.timeMapping, preview)];
                    case 5:
                        _d.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        console.log('Price preview has no children, rendering default price preview', this.selectedTerm, this.selectedOffer);
                        this.renderPricePreview.renderPrice({
                            studioName: this._studioName,
                            term: this.selectedTerm,
                            offering: this.selectedOffer,
                            freeModules: this.modulesFromLocalstorage('selectableModules'),
                            paidModules: paidModules,
                            preview: preview,
                        });
                        renderedEvent = new CustomEvent('fms-rendered', {
                            detail: {
                                rendered: 'price-preview',
                            },
                        });
                        document.dispatchEvent(renderedEvent);
                        _d.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        if (!((_c = this.config.get) === null || _c === void 0 ? void 0 : _c.legacy)) {
                            //legacy is a onepager and might haven't set the studio at this point in time
                            console.error('No Studio Id defined for technology', this.config.get.technologyType, ':', this._studioId);
                        }
                        _d.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    PricePreview.prototype.getOfferings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offerings, existsForStudio, _i, _a, offer, term;
            var _this = this;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.apiWrapper.getOfferings(this._studioId)];
                    case 1:
                        offerings = _c.sent();
                        if (offerings === null || offerings === void 0 ? void 0 : offerings.length) {
                            existsForStudio = false;
                            this.offerings = offerings;
                            for (_i = 0, _a = this.offerings; _i < _a.length; _i++) {
                                offer = _a[_i];
                                term = offer.terms.find(function (a) { return String(a.id) === String(_this.termId); });
                                if (term && offer) {
                                    this.selectedTerm = term;
                                    this.selectedOffer = offer;
                                    (0, generator_const_1._HideErrorMessage)();
                                    existsForStudio = true;
                                    console.log('found selected term', term, offer);
                                    return [2 /*return*/, true];
                                }
                            }
                            if (existsForStudio === false && ((_b = this.termId) === null || _b === void 0 ? void 0 : _b.length)) {
                                console.warn('Did not find offering with id', this.termId, 'in given offerings', offerings);
                                (0, generator_const_1._ShowErrorMessage)('Dieses Angebot existiert nicht für das Studio');
                            }
                        }
                        else {
                            (0, generator_const_1._ShowErrorMessage)('Keine Angebote für Studio gefunden');
                        }
                        return [2 /*return*/, false];
                }
            });
        });
    };
    PricePreview.prototype.getMagiclinePreview = function () {
        return __awaiter(this, void 0, void 0, function () {
            var validVoucher, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.apiWrapper.validateVoucher({
                                voucherCode: undefined,
                                studioId: +(0, input_output_helper_const_1._ReadFieldFromLocalstorage)(input_mapping_const_1._AllMappings.studioId),
                                contract: (0, contract_const_1._CreateBaseContract)(),
                                customer: {
                                    city: 'test',
                                    email: 'test@test.de',
                                    firstname: 'test',
                                    lastname: 'test',
                                    countryCode: 'DE',
                                    street: 'test',
                                    zipCode: '11111',
                                    gender: 'FEMALE',
                                    houseNumber: '1',
                                    dateOfBirth: '1990-01-01',
                                    bankAccount: { accountHolder: 'test', iban: 'DE02120300000000202051' },
                                    paymentChoice: 'DIRECT_DEBIT',
                                    telephone_mobile: '+491111111',
                                },
                            })];
                    case 1:
                        validVoucher = _a.sent();
                        return [2 /*return*/, validVoucher];
                    case 2:
                        e_1 = _a.sent();
                        console.error('preview failed', e_1);
                        return [2 /*return*/, undefined];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    PricePreview.prototype.modulesFromLocalstorage = function (localstorageKey) {
        if (localStorage.getItem(localstorageKey)) {
            try {
                return JSON.parse(localStorage.getItem(localstorageKey));
            }
            catch (_a) {
                return [];
            }
        }
        return [];
    };
    /**
     * Tries to get the latest data from either dom element or localstorage based on a mapping object
     * @param mappingObject
     * @returns value or undefined
     */
    PricePreview.prototype.getPersistedData = function (mappingObject) {
        // data set form field set
        var formElement = this.$container.find("[data-set=\"".concat(mappingObject.uid, "\"]"));
        if (formElement.length > 0) {
            return formElement.val();
        }
        // legacy form field set
        formElement = this.$container.find(mappingObject['id']);
        if (formElement.length > 0 && (0, jquery_helper_const_1._IsVisible)(formElement)) {
            return formElement.val();
        }
        // local storage uid
        if (mappingObject.uid && localStorage.getItem(mappingObject.uid)) {
            return localStorage.getItem(mappingObject.uid);
        }
        // local storage legacy localstoragekey
        if (mappingObject.localStorageKey && localStorage.getItem(mappingObject.localStorageKey)) {
            return localStorage.getItem(mappingObject.localStorageKey);
        }
        return undefined;
    };
    return PricePreview;
}());
exports.PricePreview = PricePreview;
